module.exports = __webpack_public_path__ + "img/quest_icon_0031_deamon.05626ec9.png";